import {
  FulfillmentIdMap,
  type FulfillmentTypeId
} from '@carvana/merch-contracts/FulfillmentType';
import type { BulkAvailabilityPayload } from '~/contracts/common';

type AvailabilityVehicle = {
  fulfillmentType: FulfillmentTypeId;
  locationId: number;
  vehicleId: number;
};

export default function toAvailabilityPayloads(
  vehicles: Array<AvailabilityVehicle>
): Array<BulkAvailabilityPayload> {
  return vehicles.map(({ fulfillmentType, locationId, vehicleId }) => ({
    vehicleId,
    vehicleInventoryType: FulfillmentIdMap[fulfillmentType],
    vehicleLocationId: locationId
  }));
}
